import React from 'react';
import { Section } from '../ui/Section';
export function EmpathySection() {
  return <Section className="bg-brand-card/50 border-y border-white/5" data-id="element-59">
      <div className="max-w-3xl mx-auto" data-id="element-60">
        <div className="flex items-center gap-4 mb-10" data-id="element-61">
          <div className="h-[1px] flex-1 bg-gradient-to-r from-transparent to-brand-gold/50" data-id="element-62" />
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-lightGold" data-id="element-63">
            ¿Te suena familiar?
          </h2>
          <div className="h-[1px] flex-1 bg-gradient-to-l from-transparent to-brand-gold/50" data-id="element-64" />
        </div>

        <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-65">
          <p className="pl-6 border-l-2 border-brand-gold/40 py-2" data-id="element-66">
            Ese momento exacto donde ella te dice{' '}
            <span className="text-white font-medium" data-id="element-67">
              "está bien, no pasa nada"
            </span>{' '}
            y se da la vuelta para dormir... dejándote mirando al techo,
            consumido por la frustración y sabiendo que ella está insatisfecha.
          </p>

          <p className="pl-6 border-l-2 border-brand-gold/40 py-2" data-id="element-68">
            El peso aplastante de tener que decir{' '}
            <span className="text-white font-medium" data-id="element-69">
              "lo siento, es el estrés del trabajo"
            </span>{' '}
            una vez más, sintiendo cómo tu masculinidad se desmorona un poco más
            con cada excusa.
          </p>

          <p className="pl-6 border-l-2 border-brand-gold/40 py-2" data-id="element-70">
            El golpe desmoralizante de perder la firmeza justo a mitad del acto,
            viendo cómo el deseo en sus ojos se transforma en lástima o
            decepción.
          </p>

          <p className="pl-6 border-l-2 border-brand-gold/40 py-2" data-id="element-71">
            El miedo paralizante antes de siquiera intentarlo, preguntándote:{' '}
            <span className="italic" data-id="element-72">"¿Me volverá a fallar hoy?"</span>
          </p>
        </div>

        <div className="mt-12 text-center" data-id="element-73">
          <p className="text-2xl md:text-3xl font-serif font-bold text-white" data-id="element-74">
            No estás roto.{' '}
            <span className="text-brand-danger" data-id="element-75">Has sido saboteado.</span>
          </p>
        </div>
      </div>
    </Section>;
}